import Cookies from 'js-cookie'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { cn } from '@/lib/utils'
import CountryProvider from '@/context/country-context'
import { SearchProvider } from '@/context/search-context'
import { SidebarProvider } from '@/components/ui/sidebar'
import { Layout } from '@/components/layout'
import { AppSidebar } from '@/components/layout/app-sidebar'
import SkipToMain from '@/components/skip-to-main'
import GridLoader from 'react-spinners/GridLoader'
import { setToken } from '@/utils/request'
import { Suspense } from 'react'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context }) => {
    const token = await context.auth?.getToken()
    if (token) {
      setToken(token)
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const defaultOpen = Cookies.get('sidebar_state') !== 'false'
  return (
    <SearchProvider>
      <CountryProvider>
        <SidebarProvider defaultOpen={defaultOpen}>
          <SkipToMain />
          <AppSidebar />
          <div
            id='content'
            className={cn(
              'ml-auto w-full max-w-full',
              'peer-data-[state=collapsed]:w-[calc(100%-var(--sidebar-width-icon)-1rem)]',
              'peer-data-[state=expanded]:w-[calc(100%-var(--sidebar-width))]',
              'transition-[width] duration-200 ease-linear',
              'flex h-svh flex-col',
              'group-data-[scroll-locked=1]/body:h-full',
              'group-data-[scroll-locked=1]/body:has-[main.fixed-main]:h-svh'
            )}
          >
            <Layout>
              <Suspense
                fallback={
                  <div className="flex justify-center items-center h-screen w-full">
                    <GridLoader
                      color="#000"
                      size={10}
                      aria-label="Loading Spinner"
                      data-testid="loader"
                    />
                  </div>
                }
              >
                <Outlet />
              </Suspense>
            </Layout>
          </div>
        </SidebarProvider>
      </CountryProvider>
    </SearchProvider>
  )
}
